import { render, staticRenderFns } from "./PassageRenderText.vue?vue&type=template&id=a1a0486a&"
import script from "./PassageRenderText.vue?vue&type=script&lang=js&"
export * from "./PassageRenderText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PassageRenderText.vue"
export default component.exports